export const validateField = (values,actionName=null) => {
  let errors = {}
  if(actionName=='Cancel'){
    if (!values.actionComment) {
      errors.actionComment = 'Required!'
    }
    return errors
  }

  if (!values.title) {
    errors.title = 'Required!'
  }
  if (values.title && values.title.length > 200) {
    errors.title = 'Title must be less than or equal to 200 characters'
  }
  if (!values.requesterUser) {
    errors.requesterUser = 'Required!'
  }
  // if (!values.procurementReviewer) {
  //   errors.procurementReviewer = 'Required!'
  // }
  if(actionName=='SubmitToVendor'){
    if (!values.actionComment) {
      errors.actionComment = 'Required!'
    }
  }
  if(actionName=='Resubmit'){
    if (!values.actionComment) {
      errors.actionComment = 'Required!'
    }
  }
  return errors
}
